<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonService.showTour">
    <main class="page-content">
        <div class="bgColor">


            <!-- 
            <div class="card">
                <div class="card-header">
                    ADD Material Subscription
                </div>
                <div class="card-body">
                    <table class="table table-responsive table-stripped">
                        <thead>
                            <th>Category</th>
                            <th>Subscription Days</th>
                            <th>Action</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let p of payment">
                                <ng-container *ngIf="p.edit then edit else show ">


                                </ng-container>

                                <ng-template #show>
                                    <td>{{p?.admission_fees}}</td>
                                    <td>{{p?.application_fees}}</td>
                                    <td>
                                        <button class="btn btn-success" (click)="p.edit = true">Update</button>
                                    </td>
                                </ng-template>
                                <ng-template #edit>
                                    <td>
                                        <input type="number" class="form-control form-control-sm" value="{{p?.admission_fees}}" [(ngModel)]="p.admission_fees">

                                    </td>
                                    <td> <input type="number" class="form-control form-control-sm" value="{{p?.application_fees}}" [(ngModel)]="p.application_fees"> </td>
                                    <td>
                                        <button class="btn btn-success" (click)="updatePaymentSettings(p);p.edit = false">Save</button>
                                        <button class="btn btn-danger ml-1" (click)="getPaymentSettings();p.edit = false">Cancel</button>

                                    </td>
                                </ng-template>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->



            <div class="card">
                <div class="card-header">
                    Material Payment Details
                </div>
                <div class="card-body">
                    <div>
                        <div class="row">
                            <div class="col-sm-4">
                                <input type="text" placeholder="Enter user mobile number" class="form-control form-control-sm" id="search" [(ngModel)]="search.phone_num">
                            </div>

                            <div class="col-sm-4">
                                <button class="btn btn-success" (click)="getPaymentDetails()"> Filter </button>
                            </div>
                        </div>


                    </div>
                    <div class="tableView">
                        <div class="table-responsive">
                            <table class="table   ">
                                <thead>
                                    <th *ngFor="let c of tableColums">{{c}}</th>
                                    <!-- <th>Action</th> -->
                                </thead>
                                <tbody>
                                    <tr *ngFor="let p of paymentDetails">
                                        <td *ngFor="let c of tableColums">{{p[c]}}</td>
                                        <!-- <td> <i class="fa fa-download" *ngIf="p.payment_status == 'Success'" (click)="downloadInvoice(p)" aria-hidden="true" style="color:  #8686f1;"></i></td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>



                </div>
            </div>
        </div>

        <!-- <div class="backdrop" [ngStyle]="{'display':display}"></div> -->
        <!-- <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">

        </div> -->
    </main>

</div>